<!-- eslint-disable -->
<template lang="pug">
    input.datepicker-input(
         :type="inline ? 'hidden' : 'text'"
         :class="[error && 'datepicker-input--error', disabled && 'datepicker-input--disabled']"
         :name="name"
         :ref="refName"
         :id="id"
         :value="formattedValue"
         :open-date="openDate"
         :placeholder="placeholder"
         :clear-button="clearButton"
         :disabled="disabled"
         :required="required"
         autocomplete="off"
         @click="showCalendar"
         @keydown="allowTyping"
         @keyup="parseTypedDate"
         @blur="inputBlurred"
    )
</template>

<script>
    /*eslint-disable*/
    import DateInput from "../../../node_modules/vuejs-datepicker/src/components/DateInput.vue"

    export default {
        name: "DateInput",
        status: "ready",
        release: "1.0.0",
        extends: DateInput,
        props: {
            /**
             * Error state of DatepickerInput
             */
            error: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .datepicker-input {
        box-sizing: border-box;

				outline: none;

				color: $x-color-black;

				width: 100%;

				border-radius: $border-radius-6;
				border: 1px solid $hsl-color-gray-74;

				font-weight: normal;
				font-size: $font-size-16;
				line-height: $font-size-19;

		    //@include inset-squish-space($space-small);

		    padding: 12px 15px;

				&:hover {
						border-color: $hsl-color-blue-56;
				}

				&:focus {
						border-color: $hsl-color-blue-56;
				}

				&:active {
						border-color: $hsl-color-blue-56;
				}

				&::placeholder {
						font-weight: lighter;
				}
    }

    .datepicker-input--error {
        border-color: $hsl-color-red-62;
        color:  $hsl-color-red-62;

        &:hover {
            border-color:  $hsl-color-red-62;
        }

        &:focus {
            border-color: $hsl-color-red-62;
        }

        &:active {
            border-color:  $hsl-color-red-62;
        }
    }

    .datepicker-input--disabled {
        cursor: not-allowed;
        pointer-events: none;
        background-color: $hsl-color-gray-74;
        color: $hsl-color-gray-74;
    }
</style>
